import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { WorkOrderResourceAddRequest, WorkOrderResourceSummary, WorkOrderResourceGlobalResponse, WorkOrderResourceProcessingRequest, WorkOrderResourceRemoveRequest, Source } from '@jms/model';
import { WorkOrderResourcesService } from '@jms/ui/ui.workorder.resources';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class ContractorWorkOrderResourcesService implements WorkOrderResourcesService {

    public readonly source = Source.ContractorPortal;

    private readonly woResourcesAPI = 'https://__tenant__/api/portal/contractor/operations/workorder/resources/';
    private readonly http = inject(HttpClient);

    constructor() { }


    public async getResources(workOrderId: string): Promise<WorkOrderResourceSummary[]> {

        const resources = await this.http.get<WorkOrderResourceSummary[]>(`${this.woResourcesAPI}${workOrderId}`)
            .pipe(
                catchError(error => {
                    return of([]);
                })
            )
            .toPromise();

        return resources;

    }

    public async add(request: WorkOrderResourceAddRequest): Promise<WorkOrderResourceGlobalResponse> {

        const result = await this.http.post<WorkOrderResourceGlobalResponse>(`${this.woResourcesAPI}add`, request)
            .pipe(
                catchError(error => {
                    return of(null);
                })
            )
            .toPromise();

        return result;
    }

    public async reissueAll(request: WorkOrderResourceProcessingRequest): Promise<WorkOrderResourceGlobalResponse> {

        const result = await this.http.post<any>(`${this.woResourcesAPI}reissue`, request)
            .pipe(
                catchError(error => {
                    return of(null);
                })
            )
            .toPromise();

        return result;
    }

    public async resend(request: WorkOrderResourceProcessingRequest): Promise<WorkOrderResourceGlobalResponse> {

        const result = await this.http.post<any>(`${this.woResourcesAPI}resend`, request)
            .pipe(
                catchError(error => {
                    return of(null);
                })
            )
            .toPromise();

        return result;
    }


    // ** Too Dangerous ( now not dangerouse any more)
    public async resumeNew(request: WorkOrderResourceProcessingRequest): Promise<any> {
        return null;
    }

    public async dispatchAll(request: WorkOrderResourceProcessingRequest): Promise<WorkOrderResourceGlobalResponse> {
        return null;
    }


    public async remove(request: WorkOrderResourceRemoveRequest): Promise<any> {

        const result = await this.http.post<WorkOrderResourceGlobalResponse>(`${this.woResourcesAPI}remove`, request)
            .pipe(
                catchError(error => {
                    return of(null);
                })
            )
            .toPromise();

        return result;

    }


    public async processingResources(request: WorkOrderResourceProcessingRequest): Promise<WorkOrderResourceGlobalResponse> {

        const result = await this.http.post<any>(`${this.woResourcesAPI}processing`, request)
            .pipe(
                catchError(error => {
                    return of(null);
                })
            )
            .toPromise();

        return result;
    }


}